// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".hero[data-v-152da749]{margin-bottom:5rem}.hero__container[data-v-152da749]{height:35.65rem}@media only screen and (min-width:600px){.hero__container[data-v-152da749]{padding:0!important}}.hero__image[data-v-152da749]{height:100%}.hero__title[data-v-152da749]{font-size:3.25rem;line-height:1.1}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
